import React from 'react';
import styled from 'styled-components';

import { renderCurrency } from '../../../components/SystemCountry';

import tests from '../../../helpers/tests';
import getFilterWithCol from '../../../helpers/getFilterWithCol';

import Types from '../../../modules/types';

const { viewerIsAdmin } = tests;

const VariationItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const skipItems = ['condition.and', [
  viewerIsAdmin,
  ['condition.testFieldValue', 'store', '==', undefined],
]];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select the store',
  url: '/stores/list',
  // getChoiceLabel: choice => choice.data.name,
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [props => props.activity !== 'create'],
  virtual: [props => props.activity !== 'create'],
}];

export const fieldPurpose = ['FieldRadio', {
  name: 'draftPurpose',
  label: 'Purpose',
  choices: Types.DRAFT_PURPOSE_LIST.map(value => ({
    value: value.id,
    label: value.label,
  })),
  initialValue: Types.DRAFT_PURPOSE[0],
  block: true,
}];

export const fieldItemsDivider = ['Divider', {
  name: 'itemsDivider',
  skip: [skipItems],
}];

export const fieldItems = ['FieldSortableList', {
  name: 'items',
  label: 'Products',
  required: true,
  condensed: true,
  skip: [skipItems],
  fields: [
    ['FieldConnectionSelect', {
      name: 'product',
      label: null,
      placeholder: 'Product',
      url: '/products',
      searchPaths: ['name'],
      rules: [['validation.isRequired']],
      getExtraQueryConditions: (props) => {
        if (!props.viewer) {
          return [];
        }
        if (props.viewer.role === 'SELLER') {
          const { store } = props.viewer;
          return store ? [{ store }] : [];
        }
        if (props.viewer.role === 'ADMIN') {
          const store = props.pageform.getFieldValue('store');
          return store ? [{ store }] : [];
        }
        return [];
      },
    }],
    getFilterWithCol(['FieldConnectionSelect', {
      name: 'sku',
      // size: 'small',
      label: null,
      placeholder: 'Variation',
      url: '/products/placeholder/variations',
      searchPaths: ['name'],
      rules: [['validation.isRequired']],
      disabled: [
        ['condition.testPageFieldValue', 'product', '==', undefined],
      ],
      valueKey: 'sku',
      getExtraQueryConditions: (props) => {
        const product = props.form.getFieldValue('product');
        return product ? [{ id: product }] : [];
      },
      // eslint-disable-next-line arrow-body-style, no-unused-vars
      getChoiceLabel: (item, field, props) => {
        return (
          <VariationItem>
            <span>
              {item.name}
            </span>
            <span style={{ opacity: 0.5 }}>
              &nbsp;
              /
              &nbsp;
              {renderCurrency({
                prefix: `${
                  Types.decimalize(item.price)
                } `,
              })}
            </span>
          </VariationItem>
        );
      },
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'quantity',
      // size: 'small',
      label: null,
      placeholder: 'Quantity',
      addonBefore: 'x',
      align: 'right',
      type: 'number',
      rules: [['validation.isRequired'], ['validation.isNumber']],
      disabled: [
        ['condition.testPageFieldValue', 'product', '==', undefined],
        ['condition.testFieldValue', 'sku', '==', undefined],
      ],
      initialValue: 1,
    }], 12),
  ],
}];

export const fieldDiscountCode = ['FieldConnectionSelect', {
  name: 'discountCode',
  placeholder: 'Optional pre-applied discount code',
  url: '/discountcodes',
  getExtraQueryConditions: (props) => {
    if (!props.viewer) {
      return [];
    }
    if (props.viewer.role === 'SELLER') {
      return [{ store: props.viewer.store }];
    }
    const store = props.form.getFieldValue('store');
    return store
    ? [{ store }]
    : [{ name: '______________' }];
  },
  searchPaths: ['name', 'code'],
}];

export const ADMIN = [
  fieldStore,
  fieldPurpose,
  fieldItemsDivider,
  fieldItems,
  fieldDiscountCode,
];

export const SELLER_MERCHANT = [
  fieldPurpose,
  fieldItems,
  fieldDiscountCode,
];

export const SELLER_REFERRAL = [];

export const SELLER_RESELLER = [
  fieldItems,
];
